import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import * as firebase from 'firebase'

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyAGm9re5T6xZ2w9Ofnm9iAX3Xx7XoQo_Oc",
  authDomain: "limeboard-prod.firebaseapp.com",
  databaseURL: "https://limeboard-prod.firebaseio.com",
  projectId: "limeboard-prod",
  storageBucket: "limeboard-prod.appspot.com",
  messagingSenderId: "456003026097",
  appId: "1:456003026097:web:650986699f9d17e8d87690",
  measurementId: "G-HF7KGRDSF1"
};
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
